import React from 'react';
import { Download, Share, Smartphone, PlusSquare, ArrowUpRight } from 'lucide-react';

interface AppInstallGuidelinesProps {
  os: 'ios' | 'android' | 'desktop' | 'unknown';
  onInstall: () => void;
}

export const AppInstallGuidelines: React.FC<AppInstallGuidelinesProps> = ({ os, onInstall }) => {
  if (os === 'unknown') {
    return null;
  }

  return (
    <div className="mt-8 bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-5 border border-purple-100 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
      <div className="absolute top-0 right-0 w-24 h-24 bg-purple-200 rounded-full mix-blend-multiply filter blur-2xl opacity-40"></div>
      
      <div className="flex items-start gap-4 relative z-10">
        <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center flex-shrink-0 border border-purple-50">
          <Smartphone className="w-6 h-6 text-purple-600" />
        </div>
        
        <div className="flex-1">
          <h3 className="text-gray-900 font-semibold text-lg mb-1">
            Install Mart-24 App
          </h3>
          
          {os === 'ios' && (
            <div className="text-gray-600 text-sm space-y-2">
              <p>For the best experience, add us to your home screen:</p>
              <ol className="list-decimal list-inside space-y-1 ml-1">
                <li className="flex items-center gap-1">
                  Tap the <Share className="w-4 h-4 text-blue-500 inline mx-1" /> icon below
                </li>
                <li className="flex items-center gap-1">
                  Select <PlusSquare className="w-4 h-4 text-gray-700 inline mx-1" /> <strong>Add to Home Screen</strong>
                </li>
              </ol>
            </div>
          )}

          {os === 'android' && (
            <div className="text-gray-600 text-sm space-y-3">
              <p>Get the native experience with fast access and notifications.</p>
              <button
                onClick={(e) => { e.preventDefault(); onInstall(); }}
                className="w-full flex items-center justify-center gap-2 bg-purple-600 text-white py-2.5 px-4 rounded-xl hover:bg-purple-700 focus:ring-4 focus:ring-purple-200 transition-all font-medium"
              >
                <Download className="w-4 h-4" />
                Install App Now
              </button>
            </div>
          )}

          {os === 'desktop' && (
            <div className="text-gray-600 text-sm space-y-3">
              <p>Install the Mart-24 app on your device for a better experience.</p>
              <button
                onClick={(e) => { e.preventDefault(); onInstall(); }}
                className="w-full flex items-center justify-center gap-2 bg-purple-600 text-white py-2.5 px-4 rounded-xl hover:bg-purple-700 focus:ring-4 focus:ring-purple-200 transition-all font-medium"
              >
                <Download className="w-4 h-4" />
                Install Desktop App
              </button>
              <p className="text-xs text-gray-500 mt-2">
                Available for iOS and Android. On mobile, tap the share or menu button to add to your home screen.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
